import { Input, InputProps } from "antd"
import React from "react"

const Password = ({ disabled, ...props }: InputProps): JSX.Element => (
  <Input.Password {...props} disabled={disabled} visibilityToggle={!disabled} />
)

export default Password
